export enum ConversationType {
    Challenges,
    Coaching,
    Groups,
    Guides,
    Recognition,
    Transform
}
